import { render } from "./VideoChat.vue?vue&type=template&id=5fe0f43f"
import script from "./VideoChat.vue?vue&type=script&lang=js"
export * from "./VideoChat.vue?vue&type=script&lang=js"

import "./VideoChat.vue?vue&type=style&index=0&id=5fe0f43f&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__